import React from "react";
import Quiz from "../Quiz";

const questions = [
  // ALGEBRA (Simplified)
  {
    questionText: "Which of the follwoing number sentences is INCORRECT?",
    options: ["5 + 6 - 6 = 6 - 6 + 5", "5 x 6 = 6 x 5", "5 + 6 = 6 + 5", "5 / 6 = 6 /5"],
    correct: "5 / 6 = 6 /5",
  },
  {
    questionText: "In x² + 4, which number is the constant?",
    options: ["x", "2", "4", "1"],
    correct: "4",
  },
  {
    questionText: "What is the value of any number to the power of 0?",
    options: ["0", "1", "2", "It depends"],
    correct: "1",
  },
  {
    questionText: "Which expression means: 5 times a number, plus 2?",
    options: ["5 + 2m", "5m + 2", "2 + m", "5m - 2"],
    correct: "5m + 2",
  },
  {
    questionText: "Simplify: -3y + 6y",
    options: ["-9y", "3y", "9y", "-6y"],
    correct: "3y",
  },
  {
    questionText: "Simplify: y - y - y",
    options: ["0", "y", "-y", "-3y"],
    correct: "-3y",
  },
  {
    questionText: "What is 2x taken away from 2y?",
    options: ["2x - 2y", "2y - 2x", "x - y", "2 + x"],
    correct: "2y - 2x",
  },
  {
    questionText: "What do you get when you solve: 2 × □ + 4 = 12?",
    options: ["2", "4", "5", "6"],
    correct: "4",
  },
  {
    questionText: "What is the missing number: 30 + □ = 50?",
    options: ["20", "25", "10", "15"],
    correct: "20",
  },
  {
    questionText: "Which of these is an equation?",
    options: ["2 + 2", "x + 3", "5 = 5", "3x - 2"],
    correct: "5 = 5",
  },

  // GEOMETRY (Simplified)
  {
    questionText: "A shape with 4 equal sides and 4 right angles is a:",
    options: ["Rectangle", "Square", "Rhombus", "Trapezium"],
    correct: "Square",
  },
  {
    questionText: "How many sides does a triangle have?",
    options: ["2", "3", "4", "5"],
    correct: "3",
  },
  {
    questionText: "How many degrees are in a triangle?",
    options: ["180°", "90°", "360°", "270°"],
    correct: "180°",
  },
  {
    questionText: "How many right angles does a rectangle have?",
    options: ["2", "3", "4", "None"],
    correct: "4",
  },
  {
    questionText: "What shape has a curved surface only?",
    options: ["Cube", "Cone", "Cylinder", "Sphere"],
    correct: "Sphere",
  },
  {
    questionText: "Which shape has 6 faces, all squares?",
    options: ["Cube", "Cone", "Pyramid", "Cylinder"],
    correct: "Cube",
  },
  {
    questionText: "What shape has a circle base and a pointy top?",
    options: ["Sphere", "Cone", "Cube", "Cylinder"],
    correct: "Cone",
  },
  {
    questionText: "Which unit do we use to measure angles?",
    options: ["cm", "grams", "degrees", "ml"],
    correct: "degrees",
  },
  {
    questionText: "What is the name of a shape with 6 sides?",
    options: ["Hexagon", "Octagon", "Pentagon", "Triangle"],
    correct: "Hexagon",
  },
  {
    questionText: "Which part of a circle goes all the way across through the middle?",
    options: ["Radius", "Arc", "Diameter", "Chord"],
    correct: "Diameter",
  },
];

export default function MathsQuiz7({ studentInfo, onComplete }) {
  return <Quiz studentInfo={studentInfo} questions={questions} onComplete={onComplete}  />;
}


